import React from 'react';

const PointAnnotationIcon: React.FC<React.SVGProps<SVGSVGElement>> = props => (
  <svg {...props} viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M13 26C20.1797 26 26 20.1797 26 13C26 5.8203 20.1797 0 13 0C5.8203 0 0 5.8203 0 13C0 20.1797 5.8203 26 13 26Z"
      fill={props.color || '#00B7FF'}
    />
    <path
      opacity="0.5"
      d="M20.0399 17.0625V8.9375L13.0004 4.875L5.96094 8.9375V17.0625L13.0004 21.125L20.0399 17.0625Z"
      fill="white"
    />
    <path
      opacity="0.5"
      d="M13.0003 9.82866C13.5818 9.82866 14.0533 9.35721 14.0533 8.77566C14.0533 8.1941 13.5818 7.72266 13.0003 7.72266C12.4187 7.72266 11.9473 8.1941 11.9473 8.77566C11.9473 9.35721 12.4187 9.82866 13.0003 9.82866Z"
      fill="white"
    />
    <path
      opacity="0.5"
      d="M9.34011 11.94C9.92167 11.94 10.3931 11.4685 10.3931 10.887C10.3931 10.3054 9.92167 9.83398 9.34011 9.83398C8.75855 9.83398 8.28711 10.3054 8.28711 10.887C8.28711 11.4685 8.75855 11.94 9.34011 11.94Z"
      fill="white"
    />
    <path
      opacity="0.5"
      d="M9.34011 16.1656C9.92167 16.1656 10.3931 15.6941 10.3931 15.1126C10.3931 14.531 9.92167 14.0596 9.34011 14.0596C8.75855 14.0596 8.28711 14.531 8.28711 15.1126C8.28711 15.6941 8.75855 16.1656 9.34011 16.1656Z"
      fill="white"
    />
    <path
      opacity="0.9"
      d="M9.34011 11.94C9.92167 11.94 10.3931 11.4685 10.3931 10.887C10.3931 10.3054 9.92167 9.83398 9.34011 9.83398C8.75855 9.83398 8.28711 10.3054 8.28711 10.887C8.28711 11.4685 8.75855 11.94 9.34011 11.94Z"
      fill="white"
    />
    <path
      opacity="0.9"
      d="M9.34011 16.1656C9.92167 16.1656 10.3931 15.6941 10.3931 15.1126C10.3931 14.531 9.92167 14.0596 9.34011 14.0596C8.75855 14.0596 8.28711 14.531 8.28711 15.1126C8.28711 15.6941 8.75855 16.1656 9.34011 16.1656Z"
      fill="white"
    />
    <path
      opacity="0.5"
      d="M16.6604 11.94C17.242 11.94 17.7134 11.4685 17.7134 10.887C17.7134 10.3054 17.242 9.83398 16.6604 9.83398C16.0789 9.83398 15.6074 10.3054 15.6074 10.887C15.6074 11.4685 16.0789 11.94 16.6604 11.94Z"
      fill="white"
    />
    <path
      opacity="0.5"
      d="M16.6604 16.1656C17.242 16.1656 17.7134 15.6941 17.7134 15.1126C17.7134 14.531 17.242 14.0596 16.6604 14.0596C16.0789 14.0596 15.6074 14.531 15.6074 15.1126C15.6074 15.6941 16.0789 16.1656 16.6604 16.1656Z"
      fill="white"
    />
    <path
      opacity="0.5"
      d="M13.0003 18.2779C13.5818 18.2779 14.0533 17.8064 14.0533 17.2249C14.0533 16.6433 13.5818 16.1719 13.0003 16.1719C12.4187 16.1719 11.9473 16.6433 11.9473 17.2249C11.9473 17.8064 12.4187 18.2779 13.0003 18.2779Z"
      fill="white"
    />
    <path
      opacity="0.5"
      d="M13.0003 14.0533C13.5818 14.0533 14.0533 13.5818 14.0533 13.0003C14.0533 12.4187 13.5818 11.9473 13.0003 11.9473C12.4187 11.9473 11.9473 12.4187 11.9473 13.0003C11.9473 13.5818 12.4187 14.0533 13.0003 14.0533Z"
      fill="white"
    />
    <path
      opacity="0.5"
      d="M13.0003 9.82866C13.5818 9.82866 14.0533 9.35721 14.0533 8.77566C14.0533 8.1941 13.5818 7.72266 13.0003 7.72266C12.4187 7.72266 11.9473 8.1941 11.9473 8.77566C11.9473 9.35721 12.4187 9.82866 13.0003 9.82866Z"
      fill="white"
    />
    <path
      opacity="0.5"
      d="M13.0003 18.2779C13.5818 18.2779 14.0533 17.8064 14.0533 17.2249C14.0533 16.6433 13.5818 16.1719 13.0003 16.1719C12.4187 16.1719 11.9473 16.6433 11.9473 17.2249C11.9473 17.8064 12.4187 18.2779 13.0003 18.2779Z"
      fill="white"
    />
    <path
      opacity="0.5"
      d="M13.0003 14.0533C13.5818 14.0533 14.0533 13.5818 14.0533 13.0003C14.0533 12.4187 13.5818 11.9473 13.0003 11.9473C12.4187 11.9473 11.9473 12.4187 11.9473 13.0003C11.9473 13.5818 12.4187 14.0533 13.0003 14.0533Z"
      fill="white"
    />
  </svg>
);

export default PointAnnotationIcon;
